export function getSplitAddress(deliveryAddress) {
  const addressSegments = deliveryAddress.split(',');
  const firstAddressSegment = addressSegments[0];
  const secondAddressSegment = addressSegments.slice(1).join();

  return {
    addressLineOne: firstAddressSegment,
    addressLineTwo: secondAddressSegment
  }
}